/**
 *
 * Button.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import { h, render, toChildArray } from 'preact';
import PropTypes from 'prop-types';

import A from './A';
import Link from './Link';
import StyledButton from './StyledButton';
import ButtonLoading from './ButtonLoading';
import ButtonPassive from './ButtonPassive';
import Wrapper from './Wrapper';
import { injectIntl, intlShape } from 'react-intl';

// Spinner
//import Spinner from 'react-spinkit'
import './spinner_style.css'

// Color available
var blue ={
  normal: '#F8CA0F',
  light: '#06c',
  dark: '#001933',
  font: '#FFFFFF',
  font_light: "#FFFFFF",
  font_dark: "#CBCBCB",
}

var yellow = {
  normal: '#F8CA0F',
  light: '#FFE372',
  dark: '#F6C705',
  font: '#003366',
  font_light: "#003366",
  font_dark: "#003366",
}

var white = {
  normal: '#FFFFFF',
  light: '#FFF4E2',
  dark: '#858585',
  font: '#0C1435',
  font_light: "#07090E",
  font_dark: "#566FA7",
}

var green = {
  normal: '#35b13c',
  light: '#3FD911',
  dark: '#57B566',
  font: '#FFF',
  font_light: "#FFF",
  font_dark: "#FFF",
}

var red = {
  normal: '#d0021b',
  light: '#FF0000',
  dark: '#A80F22',
  font: '#FFF',
  font_light: "#FFF",
  font_dark: "#FFF",
}

function Button(props) {
  //choose color
  let color;

  switch(props.color){
    case('yellow'):
      color = yellow
      break;
    
    case('white'):
      color = white
      break;

    case('green'):
      color = green
      break;

    case('red'):
      color = red
      break;

    default:
      color = blue
  }
  // Render an anchor tag
  let button;

  if(props.to){
    button = (
      <Link style={props.style} to={props.to} onClick={props.onClick} target={props.blank} color={color} size={props.size} line={props.line}>
        {toChildArray(props.children)}
      </Link>
    );
  }

  if(props.href){
    button = (
      <A style={props.style} href={props.href} onClick={props.onClick} target={props.blank} color={color} size={props.size} line={props.line}>
        {toChildArray(props.children)}
      </A>
    );
  }

  // If the Button has a handleRoute prop, we want to render a button
  if (props.handleRoute) {
    button = (
      <StyledButton style={props.style} color={color} onClick={props.handleRoute} size={props.size} line={props.line}>
        {toChildArray(props.children)}
      </StyledButton>
    );
  }

  //if loading event happen then we use loading instead
  if(props.loading){
    button = (
      <ButtonLoading style={props.style} color={color} size={props.size} line={props.line}>
      </ButtonLoading>
    );
  }else if(props.passive){
    button = (
      <ButtonPassive style={props.style} size={props.size}>
        {toChildArray(props.children)}
      </ButtonPassive>
    );
  }

  return (
    <Wrapper>
      {button}
    </Wrapper>
  );
}

Button.propTypes = {
  handleRoute: PropTypes.func,
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  intl: intlShape.isRequired,
  loadingMessage: PropTypes.object,
  passive:PropTypes.bool,
  loadingMessage: PropTypes.object,
  link: PropTypes.string,
  dispatch: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.string,
  target: PropTypes.string,
};

export default injectIntl(Button);
